module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vestibular-box"
  }, [_c('div', {
    staticClass: "vestibular-content"
  }, [_c('div', {
    staticClass: "box-form"
  }, [_c('h1', {
    staticClass: "vestibular-title mb-2 text-xs-center headline font-weight-regular"
  }, [_vm._v("\n        " + _vm._s((_vm.processo_seletivo.descricao)))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-2"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("Inscrição realizada com sucesso!")]), _vm._v(" "), _c('v-alert', {
    staticClass: "text-xs-left",
    attrs: {
      "value": true,
      "border": "top",
      "colored-border": "",
      "type": "info",
      "elevation": "2"
    }
  }, [_c('h3', [_vm._v("Muito obrigado pela sua inscrição, leia atentamente as instruções abaixo!!")]), _c('br'), _vm._v("\n            - Enviamos um e-mail com os dados da sua inscrição;"), _c('br'), _vm._v("\n            - Caso você tenha escolhido local da prova Online, receberá um link para a realização da prova, que será on-line, basta clicar no link que está\n            no e-mail."), _c('br'), _vm._v("\n            - O link ficará disponível para realização da prova por 7 dias. Se tiver alguma dificuldade com esse\n            prazo, entre em contato pelo e-mail proen@urcamp.edu.br ou clique no botão \"posso ajudar\" que está no\n            canto inferior direito da página.\n          ")])], 1), _vm._v(" "), (_vm.inscricao.linha_digitavel) ? _c('v-flex', {
    staticClass: "mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-text', [_c('h4', {
    staticClass: "title mb-2 text-xs-center"
  }, [_vm._v("Linha digitável:")]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_c('div', {
    staticClass: "linha-ditavel mb-1"
  }, [_vm._v(_vm._s(_vm.inscricao.linha_digitavel))]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.inscricao.linha_digitavel),
      expression: "inscricao.linha_digitavel",
      arg: "copy"
    }],
    attrs: {
      "color": "secondary",
      "depressed": "",
      "small": ""
    }
  }, [_vm._v("Copiar\n                  ")])], 1)]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "formas-pagamento d-flex"
  }, [_c('div', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": "",
      "href": _vm.inscricao.boleto_link,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-print"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Imprima seu boleto aqui")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": "",
      "href": _vm.inscricao.link_pagamento,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fas fa-credit-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Pague online aqui *")])])], 1)]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v("\n              * Ao clicar em pagar online você será redirecionado para o ambiente de pagamento da PagBrasil\n            ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "text-xs-center ma-2"
  }, [_c('a', {
    attrs: {
      "href": "https://urcamp.edu.br/"
    }
  }, [_vm._v("Ir para site da URCAMP")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-banner"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03c9edbb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/vestibular/components/etapas/Finalizacao.vue
// module id = 517
// module chunks = 2